export default __webpack_public_path__ + "mini-icon-android-16@2x.png";